import { render } from "./DashboardsChartsBlock.vue?vue&type=template&id=6fc0fbe3&scoped=true&ts=true"
import script from "./DashboardsChartsBlock.vue?vue&type=script&lang=ts"
export * from "./DashboardsChartsBlock.vue?vue&type=script&lang=ts"

import "./DashboardsChartsBlock.vue?vue&type=style&index=0&id=6fc0fbe3&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc0fbe3"]])

export default __exports__